
// 유저 액션 타입
export const ActionType = {
    IDLE: 0,    // 일반
    REQUEST: 1, // api 요청
    SUCCESS: 2, // 성공값 반환
    FAILURE: 3  // 실패값 반환
}
